import { render, staticRenderFns } from "./Ciguang.vue?vue&type=template&id=65a0af6c&scoped=true&"
import script from "./Ciguang.vue?vue&type=script&lang=js&"
export * from "./Ciguang.vue?vue&type=script&lang=js&"
import style0 from "./Ciguang.vue?vue&type=style&index=0&id=65a0af6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0af6c",
  null
  
)

export default component.exports